export enum ApplicationNames {
  LEGACY_ANGULAR = '@ontotext/legacy-workbench',
  NEW_ANGULAR = '@ontotext/workbench'
}
